var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 position-absolute top-0 start-0 h-100 w-100",attrs:{"id":"modal"}},[_c(_vm.component,{tag:"component",staticClass:"bg-white position-absolute top-50 start-50 translate-middle",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }